import React from "react";
import RegisterModal from "./RegisterModal";

export default function Hero({ heroImage, showRegister, onClose }) {
  // Combined phone image containing both phones
  const phoneImage = "/biznep-mainsite/biznepphone.webp";

  function LocationIcon() {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 24 24"
        fill="#0758B5"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C7.58 2 4 5.58 4 10c0 5.5 8 12 8 12s8-6.5 8-12c0-4.42-3.58-8-8-8Zm0 11.2A3.2 3.2 0 1 1 12 6.8a3.2 3.2 0 0 1 0 6.4Z" />
      </svg>
    );
  }

  function StarIcon() {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 24 24"
        fill="#0758B5"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m12 2.5 2.94 5.96 6.58.96-4.76 4.64 1.12 6.56L12 17.52l-5.88 3.1 1.12-6.56-4.76-4.64 6.58-.96L12 2.5Z" />
      </svg>
    );
  }

  function CommunityIcon() {
    return (
      <img
        src="/biznep-mainsite/community.webp"
        alt=""
        className="h-[23px] w-[30px] object-contain"
      />
    );
  }

  return (
    <section
      id="home"
      className="
        relative
        w-full
        overflow-hidden
        bg-white
        min-h-[900px]
        lg:aspect-[1272/692]
        lg:min-h-0
      "
    >
      {/* BACKGROUND */}

      <img
        src={heroImage}
        alt="Himalayan mountains and Nepalese temple"
        className="
          absolute
          inset-0
          h-full
          w-full
          object-cover
        "
      />

      {/* Mobile background overlay */}
      <div className="absolute inset-0 bg-white/25 lg:hidden" />

      {/* DESKTOP CONTENT */}

      <div className="relative hidden h-full lg:block">
        {/* LEFT CONTENT */}

        <div
          className="
            absolute
            left-[4.3%]
            top-[18.5%]
            z-30
          "
        >
          {/* Logo */}

          <div className="mb-[3%]">
            <img
              src="/biznep-mainsite/BizNepLogo.webp"
              alt="BizNep"
              className="
                h-auto
                w-[390px]
                max-w-none
              "
            />
          </div>

          {/* Heading */}

          <h1
            className="
              text-[clamp(34px,4.1vw,52px)]
              font-extrabold
              leading-[1.08]
              tracking-[-1.5px]
              text-[#102a56]
            "
          >
            Discover &amp; Support
            <br />
            Local Businesses
          </h1>

          {/* Description */}

          <p
            className="
              mt-[3%]
              max-w-[470px]
              text-[clamp(16px,1.7vw,22px)]
              leading-[1.45]
              text-[#102a56]
            "
          >
            Find great businesses, read reviews,
            <br />
            save favorites and connect with
            <br />
            businesses in your community.
          </p>

          {/* DESKTOP FEATURES */}

          <div
            className="
              mt-[7%]
              flex
              w-fit
              items-center
              gap-[18px]
              rounded-full
              border
              border-white/40
              bg-white/15
              px-5
              py-3
              shadow-sm
              backdrop-blur-xl
              backdrop-saturate-100
            "
          >
            {/* Local Businesses */}

            <div className="flex items-center gap-2">
              <LocationIcon />

              <span
                className="
                  whitespace-nowrap
                  text-[clamp(12px,1.25vw,16px)]
                  font-semibold
                  text-[#0758b5]
                "
              >
                Local Businesses
              </span>
            </div>

            <div className="h-6 w-px bg-[#b8c7d9]" />

            {/* Real Reviews */}

            <div className="flex items-center gap-2">
              <StarIcon />

              <span
                className="
                  whitespace-nowrap
                  text-[clamp(12px,1.25vw,16px)]
                  font-semibold
                  text-[#0758b5]
                "
              >
                Real Reviews
              </span>
            </div>

            <div className="h-6 w-px bg-[#b8c7d9]" />

            {/* Stronger Community */}

            <div className="flex items-center gap-2">
              <CommunityIcon />

              <span
                className="
                  whitespace-nowrap
                  text-[clamp(12px,1.25vw,16px)]
                  font-semibold
                  text-[#0758b5]
                "
              >
                Stronger Community
              </span>
            </div>
          </div>
        </div>

        {/* DESKTOP PHONE IMAGE */}

       {/* DESKTOP PHONE IMAGE */}

{!showRegister && (
  <div className="absolute inset-0 z-20">
    <img
      src={phoneImage}
      alt="BizNep mobile app"
      className="
        absolute
        left-[37.5%]
        top-[2%]
        w-[61.5%]
        max-w-none
        object-contain
      "
    />
  </div>
)}
{/* DESKTOP REGISTRATION FORM: RIGHT 50% */}

{/* DESKTOP REGISTRATION FORM: RIGHT 50% */}

{showRegister && (
  <div
    className="
      absolute
      right-0
      top-0
      z-40
      hidden
      h-full
      w-1/2
      items-start
      justify-center
      overflow-y-auto
      bg-transparent
      p-2
      lg:flex
    "
  >
    <div className="w-full">
      <RegisterModal inline onClose={onClose} />
    </div>
  </div>
)}
      </div>

      {/* MOBILE CONTENT */}

      <div
        className="
          relative
          z-30
          flex
          flex-col
          items-center
          px-5
          pb-12
          pt-12
          text-center
          lg:hidden
        "
      >
        {/* Logo */}

        <img
          src="/biznep-mainsite/BizNepLogo.webp"
          alt="BizNep"
          className="
            h-auto
            w-[270px]
            max-w-[80vw]
          "
        />

        {/* Heading */}

        <h1
          className="
            mt-8
            text-[34px]
            font-extrabold
            leading-[1.1]
            tracking-[-1px]
            text-[#102a56]
          "
        >
          Discover &amp; Support
          <br />
          Local Businesses
        </h1>

        {/* Description */}

        <p
          className="
            mt-5
            max-w-[500px]
            text-[17px]
            font-medium
            leading-[1.5]
            text-[#102a56]
          "
        >
          Find great businesses, read reviews, save favorites and connect with
          businesses in your community.
        </p>

        {/* MOBILE FEATURES */}

        <div
          className="
            mt-7
            flex
            w-full
            max-w-[500px]
            flex-wrap
            items-center
            justify-center
            gap-x-4
            gap-y-3
            rounded-xl
            bg-white/70
            px-4
            py-4
            backdrop-blur-sm
          "
        >
          <div className="flex items-center gap-2">
            <LocationIcon />
            <span className="text-sm font-semibold text-[#0758b5]">
              Local Businesses
            </span>
          </div>

          <div className="h-6 w-px bg-[#b8c7d9]" />

          <div className="flex items-center gap-2">
            <StarIcon />
            <span className="text-sm font-semibold text-[#0758b5]">
              Real Reviews
            </span>
          </div>

          <div className="h-6 w-px bg-[#b8c7d9]" />

          <div className="flex items-center gap-2">
            <CommunityIcon />
            <span className="text-sm font-semibold text-[#0758b5]">
              Stronger Community
            </span>
          </div>
        </div>

        {/* MOBILE PHONE IMAGE */}

        <div
          className="
            relative
            mt-12
            flex
            h-[420px]
            w-full
            max-w-[500px]
            items-start
            justify-center
          "
        >
          <img
            src={phoneImage}
            alt="BizNep mobile app"
            className="
              absolute
              left-1/2
              top-0
              w-[390px]
              max-w-none
              -translate-x-1/2
              object-contain
            "
          />
        </div>
      </div>

      {/* MOBILE REGISTRATION MODAL */}

      {showRegister && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4 lg:hidden">
          <div className="max-h-[90vh] w-full max-w-md overflow-y-auto rounded-xl bg-white shadow-2xl">
            <RegisterModal onClose={onClose} />
          </div>
        </div>
      )}
    </section>
  );
}